import { featureFlagClient } from '@trello/feature-flag-client';
import { sendAppStaleEventOnce } from './sendAppStaleEventOnce';
import { tenMinutesInMs } from './constants';

export const initializeStaleEventTimer = () => {
  const evergreenClientsPassiveUpdateEnabled = featureFlagClient.get(
    'fep.evergreen_clients_passive_update',
    false,
  );

  if (evergreenClientsPassiveUpdateEnabled) {
    const timer = setInterval(() => {
      const clearTimer = () => {
        clearInterval(timer);
      };
      sendAppStaleEventOnce(clearTimer);
    }, tenMinutesInMs);
  }
};
